import {
  FETCH_DOCUMENT_REQUEST,
  FETCH_DOCUMENT_SUCCESS,
  FETCH_DOCUMENT_FAILURE,
} from "../../actions/actionTypes";

const initialState = {
  loadedDocument: null,
  loading: false,
  error: null,
};

export const documentReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DOCUMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        loadedDocument: action.payload,
        error: null,
      };
    case FETCH_DOCUMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
